import gql from 'graphql-tag';
import { CommentsItemsFragment } from '../fragments/fragments.cartEndpoint';

const CommentsQuery = {
  getCommentsProduct: gql`
    query getProductCommentsById(
      $peopleId: Int
      $blocksFilter: [String!]
      $commentType: CommentsTypeTypeEnum
      $catalogId: Int
      $setLimit: Int
      $setSort: String
      $page: Int
      $withFile: Boolean
      $mainRubricId: Int
    ) {
      getProductCommentsById(
        peopleId: $peopleId
        blocksFilter: $blocksFilter
        commentType: $commentType
        catalogId: $catalogId
        setLimit: $setLimit
        setSort: $setSort
        page: $page
        withFile: $withFile
        mainRubricId: $mainRubricId
      ) {
        totalCount
        productPeopleBuy
        isAlreadyReviewed
        reviewabilityStatus
        commentsItems {
          ...CommentsItemsFragment
        }
      }
    }
    ${CommentsItemsFragment}
  `,
  peopleCommentsStats: gql`
    query peopleCommentsStats($peopleId: Int!) {
      peopleCommentsStats(peopleId: $peopleId) {
        total
        type {
          id
          title
          shortTitle
          short_title
          identify
        }
      }
    }
  `,
  addComment: gql`
    mutation addComment($data: CommentsInput!) {
      addComment(data: $data) {
        commentsModelItem {
          id
          text
          date
          people_id
        }
      }
    }
  `,
  voteForComment: gql`
    mutation voteForComment($data: CommentVoteInput!, $cartToken: String) {
      voteForComment(data: $data, cartToken: $cartToken) {
        id
        date
        votes_yes
        votes_no
        _voted
      }
    }
  `
};

export default CommentsQuery;
